import { render, staticRenderFns } from "./fetchSelect.vue?vue&type=template&id=5e3477d6"
import script from "./fetchSelect.vue?vue&type=script&lang=js"
export * from "./fetchSelect.vue?vue&type=script&lang=js"
import style0 from "./fetchSelect.vue?vue&type=style&index=0&id=5e3477d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports